module.exports = __webpack_public_path__ + "static/img/tl.2f04cd3c.svg";